import React, { useState, useCallback, useEffect } from 'react'
import ProgressBar from './ProgressBar'
import FormStep from './Steps/Form'
import styles from './index.css'
import FundsOrigin from './Steps/FundsOrigin'
import FundsRange from './Steps/FundsRange'
import PEP from './Steps/PEP'
import { useLocation, useNavigate } from 'react-router-dom'
import Spinner from 'App/components/Spinner'

const steps = [
  {
    title: 'Ingresa tus datos personales',
    shortTitle: 'Datos personales',
    component: FormStep,
    params: ['address', 'phone', 'occupation'],
  },
  {
    title: 'Selecciona de dónde provienen tus ingresos',
    shortTitle: 'Origen de ingresos',
    component: FundsOrigin,
    params: ['fundsOrigin'],
  },
  {
    title: 'Elige el rango de tus ingresos mensuales',
    shortTitle: 'Rango de ingresos',
    component: FundsRange,
    params: ['monthlyIncome'],
  },
]

const MissingInformation = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { missingParameters } = location.state || {}

  const [currentStep, setCurrentStep] = useState(0)
  const [dataWasValid, setDataWasValid] = useState(false)
  const [dataWasModified, setDataWasModified] = useState(false)
  const [missingSteps, setMissingSteps] = useState([
    {
      title: 'Eres una Persona Expuesta Políticamente?',
      shortTitle: 'PEP',
      component: PEP,
    },
  ])

  useEffect(() => {
    if (missingParameters && missingParameters.length) {
      const neededSteps = steps.filter(step => step.params.some(p => missingParameters.includes(p)))
      setMissingSteps([...neededSteps, ...missingSteps])
    }
  }, [])

  const callNextStep = useCallback(async (valid, modified) => {
    setDataWasValid(valid)
    setDataWasModified(modified)
    setCurrentStep(prev => prev + 1)
  }, [])

  const callBackStep = useCallback(() => {
    if (currentStep - 1 < 0) {
      navigate(-1)
    } else {
      setCurrentStep(prev => prev - 1)
    }
  }, [currentStep])

  const getDataWasModified = useCallback(() => dataWasModified, [dataWasModified])
  const getDataWasValid = useCallback(() => dataWasValid, [dataWasValid])

  if (!missingSteps.length || !missingSteps[currentStep]) return <Spinner />

  const CurrentStep = missingSteps[currentStep].component

  return (
    missingSteps && (
      <div className={styles.container}>
        <ProgressBar level={currentStep} steps={missingSteps.map(s => ({ title: s.shortTitle }))} />
        <CurrentStep
          callNextStep={callNextStep}
          callBackStep={callBackStep}
          getDataWasModified={getDataWasModified}
          getDataWasValid={getDataWasValid}
        />
      </div>
    )
  )
}

export default MissingInformation
